/* BriskHome — demo interactiv afisaj cantar */
(function () {
  function initDemo(root) {
    if (!root || root.dataset.briskInit === '1') return;
    root.dataset.briskInit = '1';

    var buttons = root.querySelectorAll('.food-btn');
    if (!buttons.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var raf;

    function q(sel) { return root.querySelector(sel); }

    function setFood(btn) {
      var grams  = parseFloat(btn.dataset.grams) || 100;
      var kcal   = parseFloat(btn.dataset.kcal)  || 0;
      var prot   = parseFloat(btn.dataset.prot)  || 0;
      var carb   = parseFloat(btn.dataset.carb)  || 0;
      var fat    = parseFloat(btn.dataset.fat)   || 0;

      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      q('[data-brisk-name]').textContent = btn.dataset.name || '';

      var start = parseFloat(q('[data-brisk-grams]').textContent) || 0;
      var t0 = performance.now();
      var dur = reduce ? 0 : 500;

      cancelAnimationFrame(raf);
      function frame(t) {
        var p = dur ? Math.min(1, (t - t0) / dur) : 1;
        var e = 1 - Math.pow(1 - p, 3);
        var g = Math.round(start + (grams - start) * e);
        var m = g / 100;
        q('[data-brisk-grams]').textContent = g;
        q('[data-brisk-kcal]').textContent  = Math.round(kcal * m);
        q('[data-brisk-prot]').textContent  = (prot * m).toFixed(1);
        q('[data-brisk-carb]').textContent  = (carb * m).toFixed(1);
        q('[data-brisk-fat]').textContent   = (fat  * m).toFixed(1);
        if (p < 1) raf = requestAnimationFrame(frame);
      }
      raf = requestAnimationFrame(frame);
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { setFood(b); });
    });
    setFood(buttons[0]);
  }

  function initAll() {
    document.querySelectorAll('[data-brisk-demo]').forEach(initDemo);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  // reincarcare in editorul de teme Shopify
  document.addEventListener('shopify:section:load', initAll);
  initAll();
})();
